const applications = {
    page_title: 'Заявки',
    title: 'Заявки',
    subtitle: 'Настроить аутентификацию Logto для вашего нативного, одностраничного, машина-машина или традиционного приложения.',
    subtitle_with_app_type: 'Настроить аутентификацию Logto для вашего приложения {{name}}',
    create_device_flow_description: 'Создайте нативное приложение, использующее OAuth 2.0 Device Authorization Grant для устройств с ограниченным вводом или headless-приложений.',
    create: 'Создать заявку',
    create_third_party: 'Создать стороннее приложение',
    create_thrid_party_modal_title: 'Создать стороннее приложение ({{type}})',
    application_name: 'Название приложения',
    application_name_placeholder: 'Мое приложение',
    application_description: 'Описание приложения',
    application_description_placeholder: 'Введите описание вашего приложения',
    select_application_type: 'Выбрать тип приложения',
    no_application_type_selected: 'Вы еще не выбрали тип приложения',
    application_created: 'Приложение успешно создано.',
    tab: {
        my_applications: 'Мои приложения',
        third_party_applications: 'Приложения сторонних разработчиков',
    },
    app_id: 'Идентификатор приложения',
    type: {
        native: {
            title: 'Нативное приложение',
            subtitle: 'Приложение, работающее в нативной среде',
            description: 'Например, приложение для iOS, приложение для Android, десктопное приложение, ТВ, CLI',
        },
        spa: {
            title: 'Одностраничное приложение',
            subtitle: 'Приложение, работающее в веб-браузере и динамически обновляющее данные на месте',
            description: 'Например, приложение React DOM, приложение Vue',
        },
        traditional: {
            title: 'Традиционное веб-приложение',
            subtitle: 'Приложение, которое отображает и обновляет страницы только через веб-сервер',
            description: 'Например, Next.js, PHP',
        },
        machine_to_machine: {
            title: 'Машина-машина',
            subtitle: 'Приложение (обычно сервис), которое напрямую общается с ресурсами',
            description: 'Например, бэкэнд-сервис',
        },
        protected: {
            title: 'Защищенное приложение',
            subtitle: 'Приложение, защищенное Logto',
            description: 'N/А',
        },
        saml: {
            title: 'SAML-приложение',
            subtitle: 'Приложение, которое используется в качестве соединителя SAML IdP',
            description: 'Например, SAML',
        },
        third_party: {
            title: 'Приложение сторонних разработчиков',
            subtitle: 'Приложение, используемое в качестве коннектора стороннего поставщика идентификации',
            description: 'Например, OIDC, SAML',
        },
    },
    authorization_flow: {
        title: 'Поток авторизации',
        tooltip: 'Выберите поток авторизации для вашего приложения. После установки его нельзя будет изменить.',
        authorization_code: {
            title: 'Authorization code',
            description: 'Тип авторизации по умолчанию и наиболее распространённый. Пользователи перенаправляются на страницу входа для непосредственной авторизации доступа.',
        },
        device_flow: {
            title: 'Device flow',
            description: 'Для устройств с ограниченным вводом или безголовых приложений (например, телевизоров, CLI). Пользователи завершают вход на отдельном устройстве, вводя код устройства или сканируя QR-код.',
        },
    },
    placeholder_title: 'Выберите тип приложения, чтобы продолжить',
    placeholder_description: 'Logto использует сущность приложения для OIDC для выполнения задач, таких как идентификация ваших приложений, управление входом в систему и создание журналов аудита.',
    third_party_application_placeholder_description: 'Используйте Logto в качестве поставщика удостоверений, чтобы предоставить авторизацию OAuth сторонним сервисам. \n Включает предустановленный экран согласия пользователя для доступа к ресурсам. <a>Подробнее</a>',
    dynamic_app: {
        title: 'Динамическое приложение',
        subtitle: 'CIMD',
        description: 'Динамическое приложение позволяет OAuth-клиентам подключаться без предварительной регистрации.',
        settings_description: 'Динамическое приложение позволяет OAuth-клиентам подключаться без предварительной регистрации. Используется спецификация OAuth Client ID Metadata Document (CIMD).',
        beta_notice: 'Динамическое приложение сейчас находится в бета-тестировании. Добро пожаловать, чтобы изучить его и <ContactLink>поделиться своими отзывами</ContactLink>.',
        app_id_placeholder: 'Предоставляется каждым клиентом динамически',
        enable_confirm_modal: {
            title: 'Включить динамический доступ клиентов?',
            content: 'Любой OAuth-клиент с действительным публичным HTTPS URL идентификатора клиента может начать авторизацию для этого арендатора без предварительной регистрации. Доступ по-прежнему ограничен вашими максимальными разрешениями и согласием пользователя.',
            beta_pricing_notice: 'Динамическое приложение бесплатно в период бета-тестирования. После его завершения может взиматься плата за дополнение. Мы предупредим вас заранее, и вы сможете отключить функцию в любой момент.',
        },
        enabled: 'Динамическое приложение успешно включено.',
        disable_confirm_modal: {
            title: 'Отключить динамическое приложение?',
            content: 'CIMD-клиенты больше не смогут начинать новые запросы авторизации. Существующие разрешения сохранятся, а уже выданные токены доступа могут оставаться действительными до истечения срока.',
        },
        disabled: 'Динамическое приложение успешно отключено.',
        permissions: {
            user_title: 'Пользователь',
            user_description: 'Выберите разрешения, запрашиваемые клиентами OAuth для доступа к определенным данным пользователя.',
            grant_user_level_permissions: 'Предоставить разрешения пользователя',
            organization_title: 'Организация',
            organization_description: 'Выберите разрешения, запрашиваемые клиентами OAuth для доступа к определенным данным организации.',
            grant_organization_level_permissions: 'Предоставить разрешения организации',
            permission_delete_confirm: 'Это действие удалит разрешение из динамического приложения, из-за чего клиенты OAuth не смогут запрашивать авторизацию пользователя для него. Вы уверены, что хотите продолжить?',
        },
        client_compatibility: {
            title: 'Совместимость с клиентами',
            description: 'Настройте, как Logto обрабатывает запросы авторизации от OAuth-клиентов, которые пока не полностью поддерживают OpenID Connect. Эти настройки экспериментальные и могут быть изменены или удалены.',
            add_consent_prompt_for_offline_access: 'Добавлять запрос согласия для офлайн-доступа',
            add_consent_prompt_for_offline_access_description: 'Когда OAuth-клиент запрашивает `offline_access` без `prompt=consent`, Logto добавляет запрос согласия, чтобы клиент мог получить Refresh Token. Рекомендуется для таких клиентов, как ChatGPT и Codex.',
        },
    },
    guide: {
        third_party: {
            title: 'Интегрировать стороннее приложение',
            description: 'Используйте Logto в качестве поставщика удостоверений, чтобы предоставить OAuth-авторизацию сторонним сервисам. Включает предустановленный экран согласия пользователя для безопасного доступа к ресурсам. <a>Узнать больше</a>',
        },
    },
};
export default Object.freeze(applications);
